module.exports = __webpack_public_path__ + "static/media/sd.aafc9cae.svg";